import { useMemo, useState } from 'react';
import { TransactionResultStatus } from 'components';
import { BaseDomainModel, IPagination } from 'types';

export const useStxsTab = () => {
  const [isLoading, setLoading] = useState(false);
  const [searchDomainResult, setSearchDomainResult] = useState<BaseDomainModel[] | undefined>();
  const [currentPage, setCurrentPage] = useState(0);
  const [pagination, setPagination] = useState<IPagination>();
  const [transferredAsset, setTransferredAsset] = useState('');
  const [instantSendDialogShown, setInstantSendDialogShown] = useState(false);
  const [transactionMessagePopupShown, setTransactionMessagePopupShown] = useState(false);
  const [transactionResultStatus, setTransactionResultStatus] = useState<TransactionResultStatus>();
  const [transactionResultMessage, setTransactionResultMessage] = useState('');

  return useMemo(
    () => ({
      isLoading,
      setLoading,
      searchDomainResult,
      setSearchDomainResult,
      currentPage,
      setCurrentPage,
      pagination,
      setPagination,
      transferredAsset,
      setTransferredAsset,
      instantSendDialogShown,
      setInstantSendDialogShown,
      transactionMessagePopupShown,
      setTransactionMessagePopupShown,
      transactionResultStatus,
      setTransactionResultStatus,
      transactionResultMessage,
      setTransactionResultMessage,
    }),
    [
      isLoading,
      searchDomainResult,
      currentPage,
      pagination,
      transferredAsset,
      instantSendDialogShown,
      transactionMessagePopupShown,
      transactionResultStatus,
      transactionResultMessage,
    ]
  );
};
